import PropTypes from 'prop-types';
import { CheckCheck, History, PencilLine, Plus } from 'lucide-react';

import { Button } from '#/modules/commonComponents/button';
import useRepairRequestCorrectionActions from
  '#/modules/crmMgmt/aftersales/repairRequest/hooks/useRepairRequestCorrectionActions';

/**
 * 處理中：更正、新增品項、更正紀錄；移除後待確認時多「完成報修單」。dialogs 由呼叫端掛。
 * compact（詳情頁）：新增品項與更正紀錄在下方分頁，這裡不重複。
 */
export const RepairRequestCorrectionButtons = ({ actions, compact = false }) => {
  if (!actions?.enabled) {
    return null;
  }
  return (
    <>
      {actions.completionPending ? (
        <Button disabled={actions.isPending} onClick={actions.completeAfterRemoval}>
          <CheckCheck className="size-3.5" aria-hidden />
          完成報修單
        </Button>
      ) : null}
      <Button variant="outline" disabled={actions.isPending} onClick={actions.openCorrection}>
        <PencilLine className="size-3.5" aria-hidden />
        更正
      </Button>
      {compact ? null : (
        <>
          <Button variant="outline" disabled={actions.isPending} onClick={actions.openAddLine}>
            <Plus className="size-3.5" aria-hidden />
            新增品項
          </Button>
          <Button variant="outline" onClick={actions.openHistory}>
            <History className="size-3.5" aria-hidden />
            更正紀錄
          </Button>
        </>
      )}
    </>
  );
};

RepairRequestCorrectionButtons.propTypes = {
  compact: PropTypes.bool,
  actions: PropTypes.shape({
    enabled: PropTypes.bool,
    isPending: PropTypes.bool,
    completionPending: PropTypes.bool,
    openCorrection: PropTypes.func,
    openAddLine: PropTypes.func,
    openHistory: PropTypes.func,
    completeAfterRemoval: PropTypes.func,
  }),
};

/** 側欄等沒有共用 actions 的地方：自己建 hook 並掛 dialogs。 */
const RepairRequestCorrectionButtonsStandalone = ({ detail, onRefetch }) => {
  const actions = useRepairRequestCorrectionActions(detail, onRefetch);
  return (
    <>
      {actions.dialogs}
      <RepairRequestCorrectionButtons actions={actions} />
    </>
  );
};

RepairRequestCorrectionButtonsStandalone.propTypes = {
  detail: PropTypes.object.isRequired,
  onRefetch: PropTypes.func,
};

export default RepairRequestCorrectionButtonsStandalone;
